export default __webpack_public_path__ + "static/media/fontawesome-webfont.3fe9d36e.svg";